import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileProductsOpen, setIsMobileProductsOpen] = useState(false);
  const [isMobileCompanyOpen, setIsMobileCompanyOpen] = useState(false);

  const mobileMenuRef = useRef(null);
  const mobileMenuButtonRef = useRef(null);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileProductsOpen(false);
    setIsMobileCompanyOpen(false);
  };

  const toggleMobileProducts = () => {
    setIsMobileProductsOpen(!isMobileProductsOpen);
  };

  const toggleMobileCompany = () => {
    setIsMobileCompanyOpen(!isMobileCompanyOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        mobileMenuButtonRef.current &&
        !mobileMenuButtonRef.current.contains(event.target)
      ) {
        closeMobileMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 200);
      }
    }
  }, [location]);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src="/images/logo1.svg" alt="Peak Mobile Logo" />
          </Link>
        </div>

        

        {/* Desktop Navigation */}
        <nav className="navigation desktop-navigation">
        <div className="nav-item">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              Home
            </Link>
          </div>


          {/* ─────────── PRODUCTS DROPDOWN ─────────── */}
          <div
            className="dropdown-wrapper"
            onMouseEnter={() => setIsProductsOpen(true)}
            onMouseLeave={() => setIsProductsOpen(false)}
          >
            <div className="nav-item">
              <div className="nav-link-container">
                <Link
                  to="#"
                  className={`nav-link ${
                    location.pathname.includes('/bulk-data') ||
                    location.pathname.includes('/communication')
                      ? 'active'
                      : ''
                  }`}
                  onClick={(e) => e.preventDefault()}
                >
                  Solutions
                  <img
                    src="/images/down-arrow.png"
                    alt="dropdown"
                    className={`dropdown-arrow-img ${
                      isProductsOpen ? 'rotated' : ''
                    }`}
                  />
                </Link>
              </div>
            </div>

            {isProductsOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-menu-content">
                  <Link to="/bulk-data" className="dropdown-item">
                    <img
                      src="/images/data.svg"
                      alt="Bulk Data"
                      className="dropdown-icon"
                    />
                    Bulk Data
                  </Link>
                  <Link to="/bulk-sms" className="dropdown-item">
                    <img
                      src="/images/sms.svg"
                      alt="SMS"
                      className="dropdown-icon"
                    />
                    SMS
                  </Link>
                  <Link to="/bulk-whatsapp" className="dropdown-item">
                    <img
                      src="/images/whatsapp.svg"
                      alt="WhatsApp"
                      className="dropdown-icon"
                    />
                    WhatsApp
                  </Link>
                  <Link to="/airtime-rewards" className="dropdown-item">
                    <img
                      src="/images/airtimenav.svg"
                      alt="Bulk Airtime"
                      className="dropdown-icon"
                    />
                    Bulk Airtime
                  </Link>
                  <Link to="/communication" className="dropdown-item">
                    <img
                      src="/images/whatsapp.svg"
                      alt="Multichannels"
                      className="dropdown-icon"
                    />
                    Multichannels
                  </Link>
                  <Link to="/gamify" className="dropdown-item">
                    <img
                      src="/images/icons/win.svg"
                      alt="Gamification"
                      className="dropdown-icon"
                    />
                    Gamification
                  </Link>
                  <a
                    href="https://mypoints.peakmobile.co.ke/"
                    className="dropdown-item"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/icons/reward.svg"
                      alt="Loyalty"
                      className="dropdown-icon"
                    />
                    Loyalty
                  </a>
                </div>

                <div className="dropdown-menu-description">
                Explore our full suite of digital engagement tools
                </div>
              </div>
            )}
          </div>



          {/* ─────────── REMAINING LINKS ─────────── */}
          <div className="nav-item">
            <Link to="/pricing" className={`nav-link ${isActive('/pricing') ? 'active' : ''}`}>
              Pricing
            </Link>
          </div>

          <div className="nav-item">
            <Link to="/developers" className={`nav-link ${isActive('/developers') ? 'active' : ''}`}>
              Developers
            </Link>
          </div>

          {/* ─────────── SERVICES DROPDOWN ─────────── */}
          <div
            className="dropdown-wrapper"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={() => setIsServicesOpen(false)}
          >
            <div className="nav-item">
              <div className="nav-link-container">
                <Link
                  to="#"
                  className={`nav-link ${
                    location.pathname.includes('/about') ? 'active' : ''
                  }`}
                  onClick={(e) => e.preventDefault()}
                >
                  Company
                  <img
                    src="/images/down-arrow.png"
                    alt="dropdown"
                    className={`dropdown-arrow-img ${
                      isServicesOpen ? 'rotated' : ''
                    }`}
                  />
                </Link>
              </div>
            </div>

            {isServicesOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-menu-content">
                  <Link to="/about" className="dropdown-item">
                    <img
                      src="/images/surveys.svg"
                      alt="Gamification"
                      className="dropdown-icon"
                    />
                    About Us
                  </Link>
                  <Link to="/careers" className="dropdown-item">
                    <img
                      src="/images/icons/refer.svg"
                      alt="Premium SMS"
                      className="dropdown-icon"
                    />
                    Careers
                  </Link>
                </div>

                <div className="dropdown-menu-description">
                Who We Are
                </div>
              </div>
            )}
          </div>

          <div className="nav-item">
            <Link to="/contact-us" className={`nav-link ${isActive('/contact-us') ? 'active' : ''}`}>
              Contact Us
            </Link>
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <button
          ref={mobileMenuButtonRef}
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        {/* Desktop Auth Buttons */}
        <div className="auth-buttons desktop-only">
          <a
            href="https://app.peakmobile.co.ke/signin"
            className="sign-in-button-header"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/icons/user.svg" alt="Sign In" className="button-icon" />
            Sign In
          </a>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <nav ref={mobileMenuRef} className="mobile-navigation">
          <div className="mobile-nav-item">
            <Link to="/" className="mobile-nav-link" onClick={closeMobileMenu}>
              Home
            </Link>
          </div>
          <div className="mobile-nav-item">
            <div className="mobile-nav-toggle" onClick={toggleMobileProducts}>
              Solutions
              <img
                src="/images/down-arrow.png"
                alt="dropdown"
                className={`dropdown-arrow-img ${isMobileProductsOpen ? 'rotated' : ''}`}
              />
            </div>

            {isMobileProductsOpen && (
              <div className="mobile-dropdown">
                <Link to="/bulk-data" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  Bulk Data
                </Link>
                <Link to="/bulk-sms" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  SMS
                </Link>
                <Link to="/airtime-rewards" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  Airtime Rewards
                </Link>
                <Link to="/communication" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  Multichannels
                </Link>
                <Link to="/gamify" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  Gamification
                </Link>
                <a
                  href="https://mypoints.peakmobile.co.ke/"
                  className="mobile-dropdown-item"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMobileMenu}
                >
                  Loyalty
                </a>
              </div>
            )}
          </div>

          <div className="mobile-nav-item">
            <Link to="/pricing" className="mobile-nav-link" onClick={closeMobileMenu}>
              Pricing
            </Link>
          </div>

          <div className="mobile-nav-item">
            <Link to="/developers" className="mobile-nav-link" onClick={closeMobileMenu}>
              Developers
            </Link>
          </div>

          <div className="mobile-nav-item">
            <div className="mobile-nav-toggle" onClick={toggleMobileCompany}>
              Company
              <img
                src="/images/down-arrow.png"
                alt="dropdown"
                className={`dropdown-arrow-img ${isMobileCompanyOpen ? 'rotated' : ''}`}
              />
            </div>

            {isMobileCompanyOpen && (
              <div className="mobile-dropdown">
                <Link to="/about" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  About Us
                </Link>
                <Link to="/careers" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  Careers
                </Link>
              </div>
            )}
          </div>

          <div className="mobile-nav-item">
            <Link to="/contact-us" className="mobile-nav-link" onClick={closeMobileMenu}>
              Contact Us
            </Link>
          </div>

          {/* Mobile Sign In Button */}
          <div className="mobile-nav-item mobile-demo-section">
            <a
              href="https://app.peakmobile.co.ke/signin"
              className="mobile-demo-button"
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: "#001F3C" }}
            >
              <img src="/images/icons/user.svg" alt="Sign In" className="button-icon" />
              Sign In
            </a>
          </div>

          {/* Mobile Demo Button */}
          <div className="mobile-nav-item mobile-demo-section">
            <Link to="/contact-us" className="mobile-demo-button" onClick={closeMobileMenu}>
              <img src="/images/icons/demo.svg" alt="Book a Demo" className="button-icon" />
              Book a Demo
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
